import api from "./api";

// MELHORIA 25 — entregas realizadas (ledger por card + relatório por dia).

export interface EntregaCard {
  id: string;
  quantidade: number;
  observacao: string | null;
  data: string;
  usuario: { id: string; nome: string; fotoUrl: string | null };
}

export async function listarEntregasCard(tarefaId: string) {
  const r = await api.get(`/tarefas/${tarefaId}/entregas`);
  return r.data.data as EntregaCard[];
}

export async function registrarEntrega(
  tarefaId: string,
  dados: { quantidade?: number; data?: string | null; observacao?: string | null },
) {
  const r = await api.post(`/tarefas/${tarefaId}/entregas`, dados);
  return r.data.data as EntregaCard;
}

export async function deletarEntrega(tarefaId: string, entregaId: string) {
  await api.delete(`/tarefas/${tarefaId}/entregas/${entregaId}`);
}

// ===== Relatório "Entregas realizadas" (gestor/admin) =====
export interface EntregaLinha {
  id: string;
  data: string;
  dia: string;
  quantidade: number;
  observacao: string | null;
  tarefaId: string;
  titulo: string;
  tipoLabel: string | null;
  tipoIcone: string | null;
  categoria: string;
  projetoNome: string | null;
  clienteId: string | null;
  clienteNome: string | null;
  usuarioId: string;
  usuarioNome: string;
  usuarioFotoUrl: string | null;
}
export interface RelatorioEntregasRealizadas {
  periodo: { inicio: string; fim: string };
  totalPecas: number;
  totalRegistros: number;
  porDia: Array<{ dia: string; totalPecas: number; entregas: EntregaLinha[] }>;
  porPessoa: Array<{ usuarioId: string; usuarioNome: string; usuarioFotoUrl: string | null; totalPecas: number }>;
  porCategoria: Array<{ categoria: string; totalPecas: number }>;
  porCliente: Array<{ clienteId: string | null; clienteNome: string; totalPecas: number }>;
}
export async function relatorioEntregasRealizadas(params: {
  inicio: string;
  fim: string;
  usuarioId?: string;
  clienteId?: string;
  categoria?: string;
}) {
  const qs = new URLSearchParams({ inicio: params.inicio, fim: params.fim });
  if (params.usuarioId) qs.append("usuarioId", params.usuarioId);
  if (params.clienteId) qs.append("clienteId", params.clienteId);
  if (params.categoria) qs.append("categoria", params.categoria);
  const r = await api.get(`/relatorios/entregas-realizadas?${qs.toString()}`);
  return r.data.data as RelatorioEntregasRealizadas;
}
